import { ChangeDetectorRef, Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { currentLocation, projectDetails, siteDetails } from '../../../../core/projects.selectors';
import { LocationPickerComponent } from '../../../../../../shared/components/location-picker/location-picker.component';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../../state/app.state';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsService } from '../../../../core/projects.service';
import { CommonService } from '../../../../../../shared/services/common.service';
import { takeUntil } from 'rxjs/operators';
import { GetVideoIdRequest, UploadFileRequest } from '../../../../../../shared/core/shared.actions';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../../../../../shared/components';
import { ProjectDetailsService } from '../tab-screens/project-details.service';
import { FormGroup } from '@angular/forms';
import { classifyFile } from '../../../../../../shared/helpers';

@Component({
    selector: 'app-project-action-section',
    templateUrl: './action-section.component.html',
    styleUrls: ['./action-section.component.scss'],
    standalone: false
})
export class ActionSectionComponent implements OnDestroy {
  @ViewChild('fileInput', { static: false }) fileInputRef: any;
  @Input() disableAddMenu = false;
  @Input() disableOptionMenu = false;
  @Input() hideDeleteOption = false;
  @Input() normalActions = true;
  form: FormGroup = new FormGroup({});
  formInputInfo: any;
  status: any = 'open';
  isFormDirty = false;
  addMenuOptions = [
    {
      key: 'picture',
      icon: 'camera-outline',
      label: 'Picture',
      handler: () => {
        this.fileInputRef.nativeElement.click();
      },
    },
    {
      key: 'location',
      icon: 'marker-outline',
      label: 'Location',
      handler: () => {
        this.store.select(currentLocation)
          .subscribe(location => {
            if (!location?.latitude || !location?.longitude) {
              this.store.select(siteDetails)
                .subscribe(site => {
                  if (site?.longitude && site?.latitude) {
                    location = {
                      latitude: site?.latitiude,
                      longitude: site?.longitude,
                    };
                  } else {
                    this.store.select(projectDetails)
                      .subscribe(project => {
                        if (project?.longitude && project?.latitude) {
                          location = {
                            latitude: project?.latitiude,
                            longitude: project?.longitude,
                          };
                        }
                      }).unsubscribe();
                  }
                }).unsubscribe();
            }

            this.dialog.open(LocationPickerComponent, {
              disableClose: true,
              data: {
                ...location,
                readOnly: false,
              },
            });
          }).unsubscribe();
      },
    },
    {
      key: 'comment',
      icon: 'pencil-outline',
      label: 'Comment',
      handler: () => {
        this.projectDetailsService.addComment.next(null);
      },
    },
  ];
  files: any[] = [];
  issue: any;
  limits: any;
  nextActions: any;
  projectId: any;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private projectDetailsService: ProjectDetailsService,
    private store: Store<fromRoot.State>,
    public dialog: MatDialog,
    public route: ActivatedRoute,
    public router: Router,
    public projectsService: ProjectsService,
    public commonService: CommonService,
    public cdRef: ChangeDetectorRef,
  ) {

    this.projectsService.nextActions
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        this.projectId = data?.projectId;
        const saveGroup = {
          name: 'save',
          actions: [
            {
              state: null,
              wf: null,
              ex: null,
              project_id: null,
              options: {
                label: 'Save',
                styles: { color: 'accent' },
                formInputs: [],
              },
            },
          ],
        };
        this.nextActions = [saveGroup, ...data.nextActions];
      });


    this.projectsService.isAnyFormDirty
      .pipe(takeUntil(this.onDestroy))
      .subscribe((dirty) => {
        this.isFormDirty = dirty;
      });

    this.projectDetailsService.disableOptionMenu
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.disableOptionMenu = true;
      });

    this.projectDetailsService.disableAddMenu
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.disableAddMenu = true;
      });

  }

  onFileSelected(event: any) {
    const files: FileList = event.target.files;  // Get selected files
    const imageFormData = new FormData();
    const videoFiles: File[] = [];

    for (let i = 0; i < files.length; i++) {
      const file = files.item(i);

      if (classifyFile(file) === 'video') {
        videoFiles.push(file);
      } else {
        imageFormData.append('inputFiles', file);
      }
    }

    if (imageFormData.has('inputFiles')) {
      this.store.dispatch(UploadFileRequest({ payload: imageFormData }));
    }

    if (videoFiles.length > 0) {
      videoFiles.forEach((videoFile: File) => {
        const videoElement = document.createElement('video');
        const reader = new FileReader();

        reader.onloadend = () => {
          videoElement.src = reader.result as string;

          videoElement.onloadedmetadata = () => {
            const videoDuration = videoElement.duration;
            const maxDuration = this.limits.upload.video_size_in_secs;

            if (videoDuration > maxDuration) {
              this.commonService.notification(`Video duration is ${videoDuration} seconds, should be less than ${maxDuration} seconds.`, 'danger');
            } else {
              this.store.dispatch(GetVideoIdRequest({ payload: videoFile }));
            }
          };
        };

        reader.readAsDataURL(videoFile);
      });
    }

    this.fileInputRef.nativeElement.value = '';
  }

  save() {
    this.projectDetailsService.triggerSave.next(null);
  }

  delete() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: new ConfirmDialogModel(
        'Delete',
        `Are you sure you want to delete this item?`,
      ),
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.projectDetailsService.triggerDelete.next(null);
      }
    });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
